import { render, staticRenderFns } from "./FavoriteIcon.vue?vue&type=template&id=24f14888&scoped=true&"
import script from "./FavoriteIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FavoriteIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f14888",
  null
  
)

export default component.exports